<div class="flex flex-col items-center p-8">
  <img src="assets/images/icons/blue-circle-check.svg" class="mb-8" />
  <span class="text-grey-700 font-bold text-lg mb-2">Initiated successfully</span>
  <span class="text-grey-700 text-base">Check details to see the progress</span>
</div>
